module.exports = __webpack_public_path__ + "img/icon-noti-lock.b0fd4ae2.svg";